<template>
  <div class="reserve-page">
    <div class="top">
      <div class="header">
        <div class="back-btn" @click="goHome">
          <van-icon name="arrow-left" color="#fff" />
          <span>返回</span>
        </div>
        <span class="title">在线预约</span>
      </div>
    </div>
    
    <div class="main">
      <div class="steps-card">
        <div class="tips">请正确填写预约信息，以确保预约成功</div>
        <div class="step-wrap">
          <div class="step-item active">
            <div class="num">1</div>
            <div class="text">预约事项</div>
          </div>
          <div class="line"></div>
          <div class="step-item">
            <div class="num">2</div>
            <div class="text">个人信息</div>
          </div>
          <div class="line"></div>
          <div class="step-item">
            <div class="num">3</div>
            <div class="text">预约时间</div>
          </div>
        </div>
      </div>
      
      <div class="form-card">
        <div class="form-item">
          <div class="label">
            <van-icon name="shop-o" color="#5892FB" />
            <span>选择部门</span>
          </div>
          <van-cell is-link @click="showDeptList">
            <template #title>
              <span class="cell-text">{{ deptText }}</span>
            </template>
          </van-cell>
        </div>
        
        <div class="form-item">
          <div class="label">
            <van-icon name="orders-o" color="#5892FB" />
            <span>选择业务</span>
          </div>
          <van-cell is-link @click="showProjectList">
            <template #title>
              <span class="cell-text">{{ projectText }}</span>
            </template>
          </van-cell>
        </div>
      </div>
    </div>
    
    <div class="footer">
      <van-button type="primary" block round @click="nextStep">下一步</van-button>
    </div>
    
    <van-action-sheet v-model="deptShow" title="选择部门" :actions="deptActions" @select="deptOnSelect" />
    <van-action-sheet v-model="projectShow" title="选择业务" :actions="projectActions" @select="projectOnSelect" />
  </div>
</template>

<script>
import { ActionSheet, Cell, Toast, Icon, Button, Dialog } from 'vant';
import { getSubscribeDeptList, getSubscribeQueueListByDeptID, getListSubscribeProjectByDeptID } from '../api/apis.js';
import { checkCanReserve } from '../utils/cancelLimitHelper.js';

export default {
  name: 'SubscribeProject',
  components: {
    [ActionSheet.name]: ActionSheet,
    [Cell.name]: Cell,
    [Toast.name]: Toast,
    [Icon.name]: Icon,
    [Button.name]: Button
  },
  data() {
    return {
      areaCode: '',
      deptShow: false,
      deptActions: [],
      deptId: '',
      deptText: '请选择部门',
      projectShow: false,
      projectActions: [],
      projectId: '',
      projectText: '请选择业务',
      projectNo: '',
      username: '',
      idcard: '',
      phone: '',
      subscribeMode: 'queue',
      fromPath: '/'  // 记录来源页面
    };
  },
  created() {
    this.username = this.$route.query.username || '';
    this.idcard = this.$route.query.idcard || '';
    this.phone = this.$route.query.phone || '';
    this.subscribeMode = window.config?.subscribeMode || 'queue';
    // 记录来源页面
    if (this.$route.query.from) {
      this.fromPath = this.$route.query.from;
    }
  },
  mounted() {
    this.areaCode = this.$route.query.areaCode || window.config?.areaCode || '';
    this.deptId = this.$route.query.deptId || '';
    this.deptText = this.$route.query.deptName || '请选择部门';
    this.projectId = this.$route.query.tasktypeguid || '';
    this.projectText = this.$route.query.projectText || '请选择业务';
    
    // 检查用户是否被限制预约
    this.checkReserveLimit();
    
    this.loadDeptList();
    if (this.deptId) this.loadProjectList();
  },
  methods: {
    // 检查预约限制
    checkReserveLimit() {
      if (!this.idcard) return;
      
      const checkResult = checkCanReserve(this.idcard);
      if (!checkResult.canReserve) {
        Dialog.alert({
          title: '无法预约',
          message: checkResult.message,
          confirmButtonText: '我知道了'
        }).then(() => {
          // 返回到来源页面
          this.$router.push(this.fromPath);
        });
      }
    },
    lastStep() {
      this.$router.push('/');
    },
    goHome() {
      // 返回到来源页面，如果来源是网点详情页，则返回地图页
      if (this.fromPath && this.fromPath.includes('/site')) {
        this.$router.push('/map');
      } else if (this.fromPath && this.fromPath !== '/') {
        this.$router.push(this.fromPath);
      } else {
        this.$router.push('/');
      }
    },
    showDeptList() {
      if (this.deptActions.length === 0) {
        Toast.loading({ message: '加载中...', forbidClick: true, duration: 0 });
        this.loadDeptList().then(() => {
          if (this.deptActions.length > 0) {
            Toast.clear();
            this.deptShow = true;
          }
        });
        return;
      }
      this.deptShow = true;
    },
    deptOnSelect(item) {
      this.deptShow = false;
      this.deptText = item.name;
      this.deptId = item.deptId;
      this.projectId = '';
      this.projectText = '请选择业务';
      this.projectActions = [];
      this.loadProjectList();
    },
    showProjectList() {
      if (!this.deptId) {
        Toast('请先选择部门');
        return;
      }
      if (this.projectActions.length === 0) {
        Toast.loading({ message: '加载中...', forbidClick: true, duration: 0 });
        this.loadProjectList().then(() => {
          if (this.projectActions.length > 0) {
            Toast.clear();
            this.projectShow = true;
          }
        });
        return;
      }
      this.projectShow = true;
    },
    projectOnSelect(item) {
      this.projectShow = false;
      this.projectText = item.name;
      this.projectId = item.projectId || item.id;
      this.projectNo = item.projectNo || '';
    },
    async loadDeptList() {
      try {
        const params = { areacode: this.areaCode };
        const res = await getSubscribeDeptList(params);
        if (res.data && res.data.success) {
          let objData = res.data.obj;
          if (!objData || (res.data.msg && res.data.msg.includes('未获取'))) {
            this.deptActions = [];
            Toast('暂无可预约部门');
            return;
          }
          if (typeof objData === 'string') {
            try { objData = JSON.parse(objData); } catch (e) { objData = []; }
          }
          const list = objData.list || objData || [];
          this.deptActions = list.map(item => ({
            name: item.dept_name || item.deptName || item.name,
            deptId: item.dept_id || item.deptId || item.id,
            deptCode: item.dept_code || item.deptCode
          }));
          if (this.deptActions.length === 0) {
            Toast('暂无可预约部门');
          }
        } else {
          Toast(res.data?.msg || '获取部门列表失败');
        }
      } catch (error) {
        console.error('获取部门列表失败:', error);
        Toast.fail('获取部门列表失败');
      }
    },
    async loadProjectList() {
      try {
        const params = { deptid: this.deptId };
        let res;
        if (this.subscribeMode === 'project') {
          res = await getListSubscribeProjectByDeptID(params);
        } else {
          res = await getSubscribeQueueListByDeptID(params);
        }
        if (res.data && res.data.success && res.data.obj) {
          let objData = res.data.obj;
          if (typeof objData === 'string') {
            try { objData = JSON.parse(objData); } catch (e) { objData = []; }
          }
          const list = Array.isArray(objData) ? objData : (objData.list || []);
          if (this.subscribeMode === 'project') {
            this.projectActions = list.map(item => ({
              name: item.project_name || item.projectName || item.name || '未知',
              projectId: item.project_id || item.projectId || item.id,
              projectNo: item.project_no || item.projectNo || item.projectno || ''
            }));
          } else {
            this.projectActions = list.map(item => ({
              name: item.gueuename || item.queuename || item.name || '未知',
              projectId: item.id,
              queuecode: item.gueuecode || item.queuecode,
              queuecount: item.queuecount,
              daycount: item.daycount
            }));
          }
          if (this.projectActions.length === 0) {
            Toast('该部门暂无可预约业务');
          }
        }
      } catch (error) {
        console.error('获取列表失败:', error);
        Toast.fail('获取列表失败');
      }
    },
    nextStep() {
      if (!this.deptId) {
        Toast.fail('请选择部门');
        return;
      }
      if (!this.projectId) {
        Toast.fail('请选择业务');
        return;
      }
      this.$router.push({
        name: 'subscribePerson',
        query: {
          username: this.username,
          idcard: this.idcard,
          phone: this.phone,
          areaCode: this.areaCode,
          deptId: this.deptId,
          deptName: this.deptText,
          tasktypeguid: this.projectId,
          projectText: this.projectText,
          projectNo: this.projectNo,
          subscribeMode: this.subscribeMode,
          from: this.fromPath
        }
      });
    }
  }
};
</script>

<style lang="scss" scoped>
.reserve-page {
  min-height: 100vh;
  background: #f5f6f7;
  display: flex;
  flex-direction: column;
}

.top {
  background: #71a5ff;
  padding: 15px;
  
  .header {
    display: flex;
    align-items: center;
    color: #fff;
    position: relative;
    
    .back-btn {
      display: flex;
      align-items: center;
      font-size: 14px;
      
      span {
        margin-left: 4px;
      }
    }
    
    .title {
      position: absolute;
      left: 50%;
      transform: translateX(-50%);
      font-size: 17px;
    }
  }
}

.main {
  flex: 1;
  padding: 15px;
  
  .steps-card {
    background: #fff;
    border-radius: 10px;
    padding: 15px;
    margin-bottom: 15px;
    
    .tips {
      font-size: 13px;
      color: #666;
      text-align: center;
      margin-bottom: 15px;
    }
    
    .step-wrap {
      display: flex;
      align-items: center;
      justify-content: center;
      
      .step-item {
        display: flex;
        flex-direction: column;
        align-items: center;
        
        .num {
          width: 28px;
          height: 28px;
          border-radius: 50%;
          background: #ddd;
          color: #999;
          display: flex;
          align-items: center;
          justify-content: center;
          font-size: 14px;
          margin-bottom: 5px;
        }
        
        .text {
          font-size: 12px;
          color: #999;
        }
        
        &.active {
          .num {
            background: #5892FB;
            color: #fff;
          }
          .text {
            color: #5892FB;
          }
        }
      }
      
      .line {
        width: 40px;
        height: 2px;
        background: #ddd;
        margin: 0 10px 20px;
      }
    }
  }
  
  .form-card {
    background: #fff;
    border-radius: 10px;
    padding: 15px;
    
    .form-item {
      margin-bottom: 15px;
      
      &:last-child {
        margin-bottom: 0;
      }
      
      .label {
        display: flex;
        align-items: center;
        margin-bottom: 10px;
        
        span {
          font-size: 15px;
          font-weight: 600;
          color: #333;
          margin-left: 8px;
        }
      }
      
      .cell-text {
        color: #999;
        font-size: 14px;
      }
      
      ::v-deep .van-cell {
        background: #f8f8f8;
        border-radius: 8px;
        padding: 12px 15px;
      }
    }
  }
}

.footer {
  padding: 15px;
  background: #fff;
  
  ::v-deep .van-button--primary {
    background: linear-gradient(135deg, #5892FB 0%, #3B7BF7 100%);
    border: none;
    height: 45px;
    font-size: 16px;
  }
}
</style>
